(function () {
  document.querySelectorAll('.tm-pdp-pairbundle').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-pb-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        root.querySelectorAll('[data-pb-panel]').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-pb-panel="' + tab.dataset.pbTab + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    root.querySelectorAll('[data-pb-panel]').forEach(function (panel) {
      var cards = panel.querySelectorAll('[data-pb-card]');
      var dots = panel.querySelectorAll('[data-pb-dot]');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = dot.dataset.pbDot;
          cards.forEach(function (c, i) { c.classList.toggle('is-active', String(i) === idx); });
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          dot.classList.add('is-active');
        });
      });
    });
  });
})();
